let es = {
  translation: {
    'English': 'Inglés',
    'Spanish': 'Español',
    "Offline": "Offline",
    'Page not found': 'Página no encontrada',
    'The requested url was not found on this server': 'La URL solicitada no se encontró en este servidor.',
    'GO HOME': 'IR A INICIO',
    'No pending messages': 'No hay mensajes pendientes',
    'Quit this message': 'Quitar este mensaje',
	'Quit all messages': 'Quitar todos los mensajes',
    'Warning': 'Advertencia',
    'Error': 'Error',
  }
}

export default es;
